import { IPhoneCallCategory } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { Pill } from '../../../../../web/components-v2/Pill';
import { DeleteConfirmDialog } from '../../../../../web/components-v2/DeleteConfirmDialog';
import { useUpdatePhoneCallCategoryMutation } from '../../../../../queries/PhoneCall/usePhoneCallCategoryMutations';
import { nearestHue } from '../categoryColors';
import { styleSheet } from '../styles';
import { CategoryCardColors } from './CategoryCardColors';
import { CategoryCardOptions } from './CategoryCardOptions';

interface IProps {
	category: IPhoneCallCategory;
	onRequestToUpdateList?: () => void;
}

export const CategoryCard: React.FC<IProps> = ({ category, onRequestToUpdateList }) => {
	const [currentCategory, setCategory] = useState(category);

	const categoryName = category?.name;

	const history = useHistory();

	const updateCategory = useUpdatePhoneCallCategoryMutation();

	const handleUpdates = (change: IPhoneCallCategory, callback?: () => void) => {
		updateCategory.mutate(change, {
			onSuccess: updated => {
				setCategory(updated);
				callback?.();
			},
		});
	};

	const [isArchiveDialogOpen, setIsArchiveDialogOpen] = useState(false);

	const handleArchive = () => {
		setIsArchiveDialogOpen(true);
	};

	const handleArchiveClose = () => {
		setIsArchiveDialogOpen(false);
	};

	const handleArchiveConfirm = () => {
		setIsArchiveDialogOpen(false);
		handleUpdates({ ...currentCategory, archived: true }, onRequestToUpdateList);
	};

	const handleColorChange = (color: string) => {
		handleUpdates({ ...currentCategory, hexColor: color });
	};

	const handleBrowse = (value: string) => () => {
		history.push(`/call-log?category=${encodeURIComponent(value)}`);
	};

	return (
		<div className={css(styleSheet.row)}>
			{updateCategory.isPending && <div className={css(styleSheet.rowBlocked)} />}

			<div className={css(styleSheet.name)}>
				<Pill variant='tag' color={nearestHue(currentCategory.hexColor)} size='medium' label={categoryName} />
			</div>

			<div className={css(styleSheet.colorGroup)}>
				<span className={css(styleSheet.label)}>Color:</span>
				<CategoryCardColors onChange={handleColorChange} defaultColor={currentCategory.hexColor} />
			</div>

			<div className={css(styleSheet.usageGroup)}>
				<span className={css(styleSheet.label)}>Calls with this tag:</span>
				<span className={css(styleSheet.usage)}>{currentCategory.usage}</span>
			</div>

			<CategoryCardOptions onClickToArchive={handleArchive} onClickToBrowse={handleBrowse(categoryName)} />

			<DeleteConfirmDialog
				open={isArchiveDialogOpen}
				title={`Archive category: ${currentCategory.name}?`}
				description='Archiving removes this category from the list.'
				confirmLabel='Confirm'
				onClose={handleArchiveClose}
				onConfirm={handleArchiveConfirm}
			/>
		</div>
	);
};
